  import { checkOnboardingPopup } from '../apiService';

/**
 * Check if user has seen an onboarding step (auto-marks as seen on server if not)
 * @param {string} onboardingStep - The onboarding step to check
 * @returns {Promise<boolean>} Returns false if step was newly seen (should show popup), true if already seen
 */
export async function checkOnboardingStep(onboardingStep: string): Promise<boolean> {
    
  return new Promise((resolve) => {
    checkOnboardingPopup(onboardingStep, (result, status) => {
      if (status === 200) {
        // Return the inverse of has_seen
        // false = should show popup (was newly seen)
        // true = don't show popup (already seen)
        resolve(result.has_seen);
      } else {
        // API error, assume not seen to be safe (show popup)
        console.error(`Failed to check onboarding step '${onboardingStep}', status: ${status}`);
        resolve(false);
      }
    });
  });
}